import React from "react";
import { CheckIcon, ClockIcon, TargetIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { SectionHeading } from "../SectionHeading";
import { stages } from "../../data/framework";
export function Framework() {
  return <section className="bg-navy-900 px-4 py-16 text-white sm:px-6 sm:py-20" data-id="element-245" data-mp="28yhozx9py95c">
      <div className="mx-auto max-w-4xl" data-id="element-246" data-mp="2dwjdwyttt2oq">
        <SectionHeading tone="dark" kicker="Introducing the 15-Minute Alopecia Assessment Framework™" title="A simple 5-stage roadmap for organizing your initial hair loss assessment." intro="I want you to have a practical educational framework you can follow whenever you need to organize the information relevant to a hair loss presentation. That’s why the collection is built around five stages." data-id="element-247" data-mp="1z8y82x5kgpd4" />

        <div className="mt-10" aria-hidden="true" data-id="element-248" data-mp="1gbdh9kj8rgpv">
          <div className="flex h-12 w-full gap-1 overflow-hidden rounded-xl" data-id="element-249" data-mp="1l95jb7dloj7s">
            {stages.map(s => <div key={s.number} style={{
            flexGrow: s.minutes
          }} className="flex basis-0 items-center justify-center bg-brand font-display text-lg font-extrabold even:bg-brand-light even:text-navy-950" data-id="element-250" data-mp="2yybf4qjfjdiv">
                {s.minutes}m
              </div>)}
          </div>
          <p className="mt-2 text-center text-sm font-semibold text-white/70" data-id="element-251" data-mp="33yfozxpu1a04">
            Target workflow: 15 minutes
          </p>
        </div>

        <ol className="mt-10 space-y-5" data-id="element-252" data-mp="2b9igunfc4tl3">
          {stages.map(stage => <li key={stage.number} className="rounded-3xl bg-white p-5 text-ink sm:p-7" data-id="element-253" data-mp="2b7fgpakgxk2n">
              <div className="flex items-start gap-4" data-id="element-254" data-mp="2p2rmcd05wuyc">
                <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-brand font-display text-3xl font-extrabold text-white" data-id="element-255" data-mp="2k8vpxezjrg5a">
                  {stage.number}
                </span>
                <div className="min-w-0" data-id="element-256" data-mp="1shzemit4xjk4">
                  <p className="text-xs font-bold uppercase tracking-[0.14em] text-brand" data-id="element-257" data-mp="3rninr5z6v5pr">
                    Stage {stage.number}
                  </p>
                  <h3 className="font-display text-2xl font-extrabold uppercase leading-tight sm:text-3xl" data-id="element-258" data-mp="fwn7m7rnjd4">
                    {stage.title}
                  </h3>
                  <p className="mt-1.5 inline-flex items-center gap-1.5 rounded-full bg-gold-soft px-3 py-1 text-sm font-bold text-ink" data-id="element-259" data-mp="a7kbje910kad">
                    <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-260" data-mp="38q7p9nldsgbd" />
                    Target workflow time: {stage.minutes} minutes
                  </p>
                </div>
              </div>
              <p className="mt-5 font-semibold text-ink" data-id="element-261" data-mp="3il9e0ibqvgdf">{stage.intro}</p>
              <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-262" data-mp="3nm74di6wrgq0">
                {stage.items.map(item => <li key={item} className="flex items-start gap-2.5 leading-snug" data-id="element-263" data-mp="xvk2ofa92cph">
                    <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-success" strokeWidth={3} aria-hidden="true" data-id="element-264" data-mp="12uwz9rqxay59" />
                    {item}
                  </li>)}
              </ul>
              <p className="mt-5 flex items-start gap-2.5 rounded-xl bg-brand-soft p-3.5 leading-snug" data-id="element-265" data-mp="2iee27k5qyj33">
                <TargetIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand" aria-hidden="true" data-id="element-266" data-mp="2dmw0uuztaghl" />
                <span data-id="element-267" data-mp="28pmb1e8ig2t8">
                  <strong data-id="element-268" data-mp="28ob9ll2jf75a">Your objective:</strong> {stage.objective}
                </span>
              </p>
            </li>)}
        </ol>

        <div className="mt-12 text-center" data-id="element-269" data-mp="1zoeh18d11o4y">
          <p className="font-display text-4xl font-extrabold uppercase leading-tight sm:text-5xl" data-id="element-270" data-mp="1znd1aql2gdgw">
            5 stages. <span className="text-gold" data-id="element-271" data-mp="1upbmihuob0b8">One organized clinical roadmap.</span>
          </p>
          <p className="mt-2 text-lg font-semibold text-white/80" data-id="element-272" data-mp="1prjiipgr7nqo">Target workflow: 15 minutes.</p>
          <p className="mx-auto mt-4 max-w-2xl text-xs leading-relaxed text-white/55" data-id="element-273" data-mp="3p2kn1k58rbhc">
            The time allocations are proposed design targets for an initial review when relevant
            information is already available. They are not validated completion times and do not
            include the full consultation, examination, investigations, or diagnostic process.
          </p>
        </div>

        <CTAButton className="mt-8" tone="dark" label="Yes! I want the complete clinical roadmap" note="One-time payment · $27 USD" data-id="element-274" data-mp="27rvzppsh23a8" />
      </div>
    </section>;
}